module.exports = __webpack_public_path__ + "static/media/undraw-heartbroken-cble.77e0fd00.svg";